import * as i0 from '@angular/core';
import * as i1 from './stepper.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '../icon/icon.component';
import * as i6 from './stepper.component';
import * as i7 from './step.component';
import * as i8 from './stepper-button.directive';
import * as i9 from '../shared/shared.module';
import * as i10 from '../icon/icon.module';
export const ElStepperModuleNgFactory:i0.NgModuleFactory<i1.ElStepperModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_y = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_38:i5.ElIconComponent = (<any>(null as any));
var _decl0_39:i6.ElStepperComponent = (<any>(null as any));
var _decl0_40:i7.ElStepComponent = (<any>(null as any));
var _decl0_41:i8.ElStepperNextDirective = (<any>(null as any));
var _decl0_42:i8.ElStepperPreviousDirective = (<any>(null as any));
var _decl0_43:i2.AsyncPipe = (<any>(null as any));
var _decl0_44:i2.UpperCasePipe = (<any>(null as any));
var _decl0_45:i2.LowerCasePipe = (<any>(null as any));
var _decl0_46:i2.JsonPipe = (<any>(null as any));
var _decl0_47:i2.SlicePipe = (<any>(null as any));
var _decl0_48:i2.DecimalPipe = (<any>(null as any));
var _decl0_49:i2.PercentPipe = (<any>(null as any));
var _decl0_50:i2.TitleCasePipe = (<any>(null as any));
var _decl0_51:i2.CurrencyPipe = (<any>(null as any));
var _decl0_52:i2.DatePipe = (<any>(null as any));
var _decl0_53:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_54:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_55:i2.KeyValuePipe = (<any>(null as any));
var _decl0_56:i9.ElSharedModule = (<any>(null as any));
var _decl0_57:i10.ElIconModule = (<any>(null as any));
var _decl0_58:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_59:i0.ElementRef<any> = (<any>(null as any));
function _View_ElStepperComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.vertical;
  currVal_0;
  const currVal_1:any = _decl0_39.horizontal;
  currVal_1;
}
function _View_ElStepperComponent_1_1():void {
  var _any:any = (null as any);
}
function _View_ElStepperComponent_1_3():void {
  if ((!_any && !_any.hidden)) {
    var _any:any = (null as any);
    const currVal_0:any = (_any <= _decl0_39.selectedIndex);
    currVal_0;
  }
}
function _View_ElStepperComponent_1_5():void {
  if ((!_any.hidden && (!_any.completed || _decl0_39.isStepSelected(_any)))) {
    var _any:any = (null as any);
    const currVal_0:any = (_any + 1);
    currVal_0;
  }
}
function _View_ElStepperComponent_1_6():void {
  if ((!_any.hidden && (!_decl0_39.isStepSelected(_any) && _any.completed))) {
    var _any:any = (null as any);
    const currVal_0:any = 'checkmark-outline';
    currVal_0;
    const currVal_1:any = 'endlessjs-essentials';
    currVal_1;
    const currVal_2:any = _decl0_38.html;
    currVal_2;
    const currVal_3:any = _decl0_38.primary;
    currVal_3;
    const currVal_4:any = _decl0_38.info;
    currVal_4;
    const currVal_5:any = _decl0_38.success;
    currVal_5;
    const currVal_6:any = _decl0_38.warning;
    currVal_6;
    const currVal_7:any = _decl0_38.danger;
    currVal_7;
  }
}
function _View_ElStepperComponent_1_8():void {
  if ((!_any.hidden && _any.isLabelTemplate)) { var _any:any = (null as any); }
}
function _View_ElStepperComponent_1_7():void {
  if ((!_any.hidden && _any.isLabelTemplate)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.label;
    currVal_0;
  }
}
function _View_ElStepperComponent_1_9():void {
  if ((!_any.hidden && !_any.isLabelTemplate)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.label;
    currVal_0;
  }
}
function _View_ElStepperComponent_1_4():void {
  if (!_any.hidden) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_39.isStepSelected(_any);
    currVal_0;
    const currVal_1:any = (!_decl0_39.isStepSelected(_any) && _any.completed);
    currVal_1;
    const currVal_2:any = _decl0_39.disableStepNavigation;
    currVal_2;
    const currVal_3:any = (!_any.completed || _decl0_39.isStepSelected(_any));
    currVal_3;
    const currVal_4:any = (!_decl0_39.isStepSelected(_any) && _any.completed);
    currVal_4;
    const currVal_5:any = _any.isLabelTemplate;
    currVal_5;
    const currVal_6:any = !_any.isLabelTemplate;
    currVal_6;
    const pd_7:any = ((<any>(!_decl0_39.disableStepNavigation && _any.select())) !== false);
  }
}
function _View_ElStepperComponent_1_2():void {
  var _any:any = (null as any);
  const currVal_0:any = (!_any && !_any.hidden);
  currVal_0;
  const currVal_1:any = !_any.hidden;
  currVal_1;
}
function _View_ElStepperComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_39.steps;
  currVal_0;
  const currVal_1:any = ((_decl0_39.selected == null)? (null as any): _decl0_39.selected.content);
  currVal_1;
}
function _View_ElStepComponent_Host_2_0():void {
  var _any:any = (null as any);
}
function _View_ElStepComponent_2_1():void {
  var _any:any = (null as any);
}
function _View_ElStepComponent_2_0():void {
  var _any:any = (null as any);
}
